import React from 'react';
import { ActionRequired } from '@sde/widgets-core/src/widgets/ActionRequired';
import PropTypes from 'prop-types';

export const ActionRequiredWidget = ({
  user,
  provider,
  actionRequiredFilter,
  setActionRequiredCount,
  setActionRequiredCallsCompleted,
  setActionRequiredFilter,
}) => {
  const widgetProps = {
    data: {
      user,
      provider,
      actionRequiredFilter,
    },
    events: {
      setTotalCount: (count) => {
        setActionRequiredCount(count > 99 ? '99+' : count);
      },
      setCallsCompleted: () => {
        setActionRequiredCallsCompleted(true);
      },
      setActionRequiredFilter: (boolean) => {
        setActionRequiredFilter(boolean);
      },
    },
  };

  return <ActionRequired {...widgetProps} />;
};

ActionRequiredWidget.propTypes = {
  user: PropTypes.shape({}).isRequired,
  provider: PropTypes.shape({}).isRequired,
  setActionRequiredCount: PropTypes.func.isRequired,
  setActionRequiredCallsCompleted: PropTypes.func,
  actionRequiredFilter: PropTypes.bool.isRequired,
  setActionRequiredFilter: PropTypes.func.isRequired,
};

ActionRequiredWidget.defaultProps = {
  setActionRequiredCallsCompleted: () => {},
};
